import React, { useEffect, useState } from 'react';
import { Field } from 'redux-form';
import { useHistory } from 'react-router-dom';
import {
  FormFields,
  FormOptions,
  FormContent,
  ShimmerContent,
  ShimmerFields,
  ShimmerSide,
  FormWrapper,
  LinkWrapper,
  FormSide,
  LinkButton,
  LinkButtonMessage,
  GenerateWrapper,
  ButtonsWrapper,
  Error,
  PageError,
  Separator,
  Title,
  CleanFieldsButton,
  GenerateButton,
  Link
} from './styled';

import {
  SELECT_DOCUMENT,
  SELECT_CURRENCY
} from './constants';
import * as cuotealoImg from './../../../../../assets/img/cuotealo.png';
import * as pagoEfectivoImg from './../../../../../assets/img/pagoEfectivo.png';
import { normalizeDecimal, normalizeAlphanumeric, normalizeText } from '@app/src/utils/normalizers';
import { FieldGroup } from '@app/src/components/Field';
import { Button } from '@app/src/components/Button';
import { Shimmer } from '@app/src/components/Shimmer';
import { required, email, date } from '@app/src/utils/validations';
import { RenderInput } from './../RenderInput';
import { RenderSelect } from './../RenderSelect';
import { RenderDatePicker } from './../RenderDatePicker';
import { RenderTimePickerContainer } from './../RenderTimePicker';
import { RenderTextArea } from './../RenderTextArea';
import { ModalContainer } from '@app/src/utils/ModalLogout';
import { RadioButton } from '@app/src/components/RadioButton';
import {
  CUOTEALO,
  PAGOEFECTIVO,
  PEN,
  MIN_AMOUNT_PE_PEN,
  MIN_AMOUNT_PE_USD
} from '@app/src/utils/validations/constants';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';

export const Form: React.FC<any> = ({
  handleSubmit,
  isFetchingProcessCip,
  errorMessageProcessCip,
  isFetchingPaymentType,
  errorMessagePaymentType,
  data,
  reset,
  pristine,
  handleCleanDocument,
  handleCleanAmount,
  handleSetPaymentType,
  handleSetFormDate,
  handleGetPaymentTypes,
  maxLength,
  paymentTypes,
  currency,
  paymentType,
  currentDate
}) => {
  const history = useHistory();
  const idCountry = decodeAccessToken('idCountry');
  const mandatoryField = decodeAccessToken('mandatoryField');
  const minValue = min => value => value && value < min ? `El monto mínimo debe ser ${min}` : undefined;

  const [ copied, setCopied ] = useState(false);
  const [ url, setUrl ] = useState('');
  const [ amountValidation, setAmountValidation ] = useState([required, minValue(MIN_AMOUNT_PE_PEN)]);

  useEffect(() => {
    handleSetFormDate(currentDate);
    if (paymentType !== String(PAGOEFECTIVO)) {
      handleSetPaymentType(String(PAGOEFECTIVO));
    }
    if (paymentTypes.length === 1) {
      handleGetPaymentTypes(history);
    }
  }, []);

  useEffect(() => {
    if (errorMessageProcessCip) {
      document.getElementById('root').scrollIntoView(scrollBehavior);
    }
    if (data.code === 100 && paymentType === String(CUOTEALO)) {
      setUrl(data.cipUrl);
    }
  });

  const selectAmountRanges = (paymentType, currency) => {
    if(paymentType === String(PAGOEFECTIVO)) {
      return currency === PEN ? MIN_AMOUNT_PE_PEN : MIN_AMOUNT_PE_USD;
    }
    if(paymentType === String(CUOTEALO)) {
      const paymentCuotealo = paymentTypes.filter((data) => data.value === String(CUOTEALO))[0];
      return currency === PEN ? paymentCuotealo.metadata.minAmountPEN : paymentCuotealo.metadata.minAmountUSD;
    }
  };

  const onPaymentTypeChange = (event) => {
    const value = event.target.value;
    setUrl('');
    handleSetPaymentType(value);
    handleCleanAmount();
    setAmountValidation([required, minValue(selectAmountRanges(value, currency))]);
  };

  const onCurrencyChange = (event) => {
    const value = event.target.value;
    handleCleanAmount();
    setAmountValidation([required, minValue(selectAmountRanges(paymentType, value))]);
  }

  const scrollBehavior = {
    behavior: 'smooth',
    block: 'start',
    inline: 'start'
  } as ScrollIntoViewOptions;


  const handleCopy = (e) => {
    e.preventDefault();
    const urlWrapper = document.createElement('input');
    urlWrapper.value = url;
    document.body.appendChild(urlWrapper);
    urlWrapper.select();
    document.execCommand('copy');
    document.body.removeChild(urlWrapper);
    setCopied(true);
  };

  const resetForm = () => {
    setUrl('');
    reset();
  };

  const submitForm = (e) => {
    setCopied(false);
    handleSubmit();
    e.preventDefault();
  }

  if (errorMessagePaymentType !== '') {
    return (
      <PageError>
        <h1>Ups!</h1>
        <span>{errorMessagePaymentType}</span>
        <span>Por favor intenta en algunos minutos.</span>
      </PageError>
    )
  }

  return (
    <>
      { isFetchingPaymentType &&
        <ShimmerContent>
          <ShimmerFields>
            <Shimmer.Line width="47%" height="35px"/>
            <Shimmer.Line width="47%" height="35px"/>
            <Shimmer.Line width="47%" height="35px"/>
            <Shimmer.Line width="47%" height="35px"/>
            <Shimmer.Line width="47%" height="35px"/>
            <Shimmer.Line width="47%" height="35px"/>
            <Shimmer.Line width="47%" height="35px"/>
            <Shimmer.Line width="47%" height="35px"/>
            <Shimmer.Line width="47%" height="35px"/>
            <Shimmer.Line width="47%" height="35px"/>
          </ShimmerFields>
          <Separator />
          <ShimmerSide>
            <Shimmer.Line width="47%" height="35px"/>
            <Shimmer.Line width="100%" height="94px"/>
            <Shimmer.Line width="100%" height="94px"/>
          </ShimmerSide>
        </ShimmerContent>
      }
      { isFetchingPaymentType ||
        <FormWrapper data-test="formGeneration" onSubmit={submitForm}>
          <Error data-test="errorMessage">{errorMessageProcessCip}</Error>
          <FormContent>
            <FormFields>

            {mandatoryField && (
              <FieldGroup>
                <Field
                  name="userName"
                  type="text"
                  maxLength="30"
                  label="Nombre (*)"
                  portionWidth={1 / 2}
                  component={RenderInput}
                  validate={[ required ]}
                  normalize={normalizeText}
                />
                <Field
                  name="userLastName"
                  type="text"
                  maxLength="30"
                  label="Apellidos (*)"
                  portionWidth={1 / 2}
                  component={RenderInput}
                  validate={[ required ]}
                  normalize={normalizeText}
                />
              </FieldGroup>
            )}            
            {mandatoryField && (
              <FieldGroup>
                <Field
                  name="userEmail"
                  type="text"
                  maxLength="100"
                  label="Email (*)"
                  portionWidth={1 / 2}
                  component={RenderInput}
                  validate={[ required, email ]}
                />
                <Field
                  name="userPhone"
                  type="number"
                  maxLength="9"
                  label="Celular"
                  portionWidth={1 / 2}
                  component={RenderInput}
                />
              </FieldGroup>
            )}
            {mandatoryField && (
              <FieldGroup keepProps>
                <Field
                  name="userDocumentType"
                  label="Documento"
                  portionWidth={1 / 2}
                  component={RenderSelect}
                  options={SELECT_DOCUMENT[ idCountry ]}
                  onChange={handleCleanDocument}
                />
                <Field
                  name="userDocumentNumber"
                  type="text"
                  maxLength={maxLength}
                  portionWidth={1 / 2}
                  component={RenderInput}
                  normalize={normalizeAlphanumeric}
                />
              </FieldGroup>
            )}

              <FieldGroup keepProps>
                <Field
                  name="currency"
                  label="Tipo de moneda (*)"
                  portionWidth={1 / 2}
                  component={RenderSelect}
                  validate={[ required ]}
                  options={SELECT_CURRENCY[ idCountry ]}
                  onChange={onCurrencyChange}
                />
                <Field
                  name="amount"
                  label="Monto (*)"
                  type="text"
                  maxLength="8"
                  autocomplete="off"
                  portionWidth={1 / 2}
                  component={RenderInput}
                  validate={amountValidation}
                  normalize={normalizeDecimal}
                />
              </FieldGroup>
              <FieldGroup keepProps>
                <Field
                  name="date"
                  label="Fecha de expiración (*)"
                  type="text"
                  portionWidth={1 / 2}
                  minDate={currentDate}
                  component={RenderDatePicker}
                  validate={[ required, date ]}
                />
                <Field
                  name="time"
                  label="Hora de expiración (*)"
                  type="text"
                  portionWidth={1 / 2}
                  component={RenderTimePickerContainer}
                  validate={[ required ]}
                />
              </FieldGroup>
              <FieldGroup>
                <Field
                  name="orderNumber"
                  label="Número de pedido"
                  type="text"
                  maxLength="36"
                  portionWidth={1}
                  component={RenderInput}
                />
              </FieldGroup>
              <FieldGroup>
                <Field
                  name="detail"
                  maxLength="50"
                  type="text"
                  label="Detalle"
                  portionWidth={1}
                  component={RenderTextArea}
                />
              </FieldGroup>
            </FormFields>
            <Separator />
            <FormSide>
              <Title>Selecciona el método de pago (*)</Title>
              <FormOptions>
                <Field
                  name="paymentType"
                  type="radio"
                  value="1"
                  onChange={onPaymentTypeChange}
                  component={({ input }) => (<RadioButton
                    {...input}
                    label="Banca móvil, agentes y bodegas vía PagoEfectivo."
                    img={pagoEfectivoImg}
                    imgHeight="55px"
                  />)}
                />
                {paymentTypes.some(payment => payment.value === String(CUOTEALO)) &&
                  <Field
                    name="paymentType"
                    type="radio"
                    value="2"
                    onChange={onPaymentTypeChange}
                    component={({ input }) => (<RadioButton
                      {...input}
                      label="Paga en cuotas sin tarjeta de crédito."
                      img={cuotealoImg}
                      imgHeight="55px"
                    />)}
                  />}
                <GenerateWrapper>
                  <Button
                    data-test="btnGenerate"
                    primary type="submit"
                    loading={isFetchingProcessCip} width="220px"
                  >
                    Generar
                  </Button>
                </GenerateWrapper>
              </FormOptions>
              {url &&
                <LinkWrapper>
                  <p>Comparte el siguiente enlace para que pueda realizar el pago:</p>
                  <Link>{url}</Link>
                  {copied ? <LinkButtonMessage>Link copiado</LinkButtonMessage> : <LinkButton onClick={(e) => handleCopy(e)}>Copiar enlace</LinkButton>}
                </LinkWrapper>
              }
            </FormSide>
          </FormContent>
          <ButtonsWrapper>
            <CleanFieldsButton type="button" icon="refresh-cw" disabled={pristine} onClick={resetForm}>Limpiar Campos</CleanFieldsButton>
            <GenerateButton data-test="btnGenerateMobile" primary type="submit" loading={isFetchingProcessCip}>Generar</GenerateButton>
          </ButtonsWrapper>
          <ModalContainer data-test="modal" reset={reset} />
        </FormWrapper>
      }
    </>
  );
};
